// @flow
import {
  GetManagerDetails,
  GetManagerDetailsSuccess,
  GetManagerDetailsError,
  GetManagerDetailsLogins,
  GetManagerDetailsLoginsSuccess,
  GetManagerDetailsLoginsError,
  GetManagerDetailsTasks,
  GetManagerDetailsTasksSuccess,
  GetManagerDetailsTasksError,
} from "@modules/reporting/constants/actions";
import type { ManagerDetailsState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: ManagerDetailsState = {
  error: null,
  requestsInProgress: 0,
  details: null,
  logins: {
    systemLogins: [],
    totalSystemLogins: 0,
  },
  tasks: {
    absenceMonitoringReviewTaskCount: 0,
    absenceMonitoringTaskCount: 0,
    list: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
    overdueCount: 0,
    referralDecisionTaskCount: 0,
    rtwInterviewTasksCount: 0,
    totalTasksCount: 0,
  },
};

export const setLoading = (state: ManagerDetailsState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetManagerDetailsSuccess = (state: ManagerDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    details: payload,
  };
};

export const onGetManagerDetailsError = (state: ManagerDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onGetManagerDetailsLoginsSuccess = (state: ManagerDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    logins: payload,
  };
};

export const onGetManagerDetailsLoginsError = (state: ManagerDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onGetManagerDetailsTasksSuccess = (state: ManagerDetailsState) => (
  payload: Object,
) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    tasks: payload,
  };
};

export const onGetManagerDetailsTasksError = (state: ManagerDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export default (state: ManagerDetailsState = initialState, action: Object): ManagerDetailsState => {
  const act = {
    [GetManagerDetails]: setLoading,
    [GetManagerDetailsSuccess]: onGetManagerDetailsSuccess,
    [GetManagerDetailsError]: onGetManagerDetailsError,
    [GetManagerDetailsLogins]: setLoading,
    [GetManagerDetailsLoginsSuccess]: onGetManagerDetailsLoginsSuccess,
    [GetManagerDetailsLoginsError]: onGetManagerDetailsLoginsError,
    [GetManagerDetailsTasks]: setLoading,
    [GetManagerDetailsTasksSuccess]: onGetManagerDetailsTasksSuccess,
    [GetManagerDetailsTasksError]: onGetManagerDetailsTasksError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
